
import * as __star__ from 'image-promise';

const {
default: __default__,

} = __star__;

export {

};
export default __default__;
